<script setup>
import { computed } from 'vue'
import { Head, Link, usePage } from '@inertiajs/vue3'
import { Plane, LogOut } from 'lucide-vue-next'
import Logo from '../Components/Logo.vue'

// Sem AppLayout: os itens do menu levariam de volta para cá, e um menu que
// não navega é pior do que menu nenhum.
defineOptions({ layout: null })

const props = defineProps({
  aircraft: { type: Array, required: true },
})

const page = usePage()
const unit = computed(() => page.props.unit ?? {})
const client = computed(() => page.props.client ?? {})
</script>

<template>
  <Head title="Aguardando" />

  <div class="flex min-h-screen items-center justify-center bg-up-navy px-4 py-10 font-sans">
    <div class="w-full max-w-md">
      <div class="mb-8 text-center text-white">
        <Logo class="text-xl" />
        <p class="mt-2 text-xs tracking-[0.18em] text-white/60 uppercase">Área do Cliente</p>
      </div>

      <div class="rounded-card bg-white p-6 shadow-card sm:p-8">
        <h1 class="text-lg font-semibold text-up-navy">Olá, {{ (client.name ?? '').split(' ')[0] }}</h1>

        <template v-if="props.aircraft.length">
          <p class="mt-2 text-sm text-slate-600">
            Não há serviço em andamento no momento. Assim que a UP Aviation abrir uma ordem de
            serviço, o acompanhamento aparece aqui.
          </p>
          <ul class="mt-5 space-y-2">
            <li
              v-for="a in props.aircraft"
              :key="a.registration"
              class="flex items-center gap-3 rounded-lg bg-up-bg px-4 py-3 text-sm"
            >
              <Plane class="h-4 w-4 shrink-0 text-up-navy" aria-hidden="true" />
              <span class="font-medium text-up-navy">{{ a.registration }}</span>
              <span class="text-slate-500">{{ a.model }}</span>
            </li>
          </ul>
        </template>

        <p v-else class="mt-2 text-sm text-slate-600">
          Ainda não há aeronave vinculada ao seu cadastro. Fale com a equipe para concluir o
          cadastro da sua aeronave.
        </p>

        <p class="mt-6 border-t border-slate-100 pt-5 text-sm text-slate-500">
          Dúvidas? Fale com a equipe
          <template v-if="unit.phone">
            pelo telefone <span class="font-medium text-up-navy">{{ unit.phone }}</span>
          </template>
          <template v-if="unit.email">
            ou por <span class="font-medium text-up-navy">{{ unit.email }}</span></template>.
        </p>
      </div>

      <div class="mt-6 text-center">
        <Link
          href="/sair"
          method="delete"
          as="button"
          type="button"
          class="inline-flex items-center gap-2 text-xs tracking-wide text-white/60 uppercase transition-colors hover:text-white"
        >
          <LogOut class="h-3.5 w-3.5" aria-hidden="true" />
          Sair
        </Link>
      </div>
    </div>
  </div>
</template>
